import { escapeHtml } from 'features/shared/utility/escapeHtml';
import htmlForPrinting from '../../../utils/htmlForPrinting';

export const buildDetailPrintHTML = (viewTarget, detailFields, title = '') => {
  const tableHtml = `
      <h4>${escapeHtml(title)}</h4>
      <table>
        <tbody>
          ${detailFields
            .map(
              ({ field, label }) =>
                `<tr><th>${escapeHtml(label)}</th><td>${escapeHtml(viewTarget[field])}</td></tr>`
            )
            .join('')}
        </tbody>
      </table>
    `;

  return htmlForPrinting(tableHtml, title);
};